import React from 'react';
export function Footer() {
  return <footer className="w-full bg-navy-dark py-10 md:py-12 px-4 md:px-6" data-id="element-108">
      <div className="max-w-4xl mx-auto text-center" data-id="element-109">
        <h3 className="text-xl md:text-2xl font-display font-bold text-gold-accent mb-2 md:mb-3" data-id="element-110">
          ฟุตบอล พร้อม
        </h3>
        <p className="text-sm md:text-base text-gray-300 mb-6 md:mb-8 leading-relaxed max-w-2xl mx-auto" data-id="element-111">
          วิธีที่ดีที่สุดในการสอนฟุตบอลโดยไม่ต้องเตรียมการเอง
          <br className="hidden sm:block" data-id="element-112" />
          เครื่องมือที่ใช้งานได้จริงสำหรับอาจารย์ที่ต้องการผลลัพธ์ที่จับต้องได้
        </p>
        <div className="border-t border-gold-accent/20 pt-6 md:pt-8" data-id="element-113">
          <p className="text-xs md:text-sm text-gray-400 mb-1 md:mb-2" data-id="element-114">
            © 2026 — สงวนลิขสิทธิ์ทั้งหมด
          </p>
          <p className="text-xs md:text-sm text-gray-500" data-id="element-115">
            สินค้าดิจิทัล — PDF ดาวน์โหลดได้ทันที
          </p>
        </div>
      </div>
    </footer>;
}